import React from "react";
import { Drawer } from "@mui/material";

function BottomSheetDrawer({
  children,
  showHandle = true,
  maxWidth = 500,
  onClose,
  open,
  paperClassName,
  paperStyle = {},
  paperSx,
  rounded = true,
  transitionDuration,
  ...drawerProps
}) {
  const width = `min(100vw, ${maxWidth}px)`;
  const centeredOffset = `max(0px, calc((100vw - ${maxWidth}px) / 2))`;

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      transitionDuration={transitionDuration}
      PaperProps={{
        className: paperClassName,
        style: {
          width,
          maxWidth: "100vw",
          left: centeredOffset,
          right: "auto",
          background: "var(--rms-v2-surface)",
          borderTopLeftRadius: rounded ? "18px" : "0px",
          borderTopRightRadius: rounded ? "18px" : "0px",
          overflow: "visible",
          ...paperStyle,
        },
        sx: paperSx,
      }}
      {...drawerProps}
    >
      {showHandle ? (
        <span
          aria-hidden="true"
          className="bottom-sheet-pull"
          style={{
            background: "var(--rms-v2-border)",
            borderRadius: "999px",
            display: "block",
            height: "5px",
            left: "50%",
            position: "absolute",
            top: "-14px",
            transform: "translateX(-50%)",
            width: "42px",
            zIndex: 2,
          }}
        />
      ) : null}
      {children}
    </Drawer>
  );
}

export default BottomSheetDrawer;
